// src/redux/languageReducer.js
import {
  TOGGLE_LANGUAGE,
  SET_LANGUAGE,
  getLanguageFromQuery,
} from "./languageActions";
import Cookies from "js-cookie";

const getStoredLanguage = () => {
  try {
    if (typeof window !== "undefined" && window.location?.search) {
      const urlLang = getLanguageFromQuery(window.location.search);
      if (urlLang !== null) {
        Cookies.set("language", urlLang.toString());
        return urlLang;
      }
    }
  } catch (e) {
    // Ignore error in non-browser or SSR contexts
  }

  const stored = Cookies.get("language");
  return stored !== undefined ? parseInt(stored, 10) : 0;
};

const initialState = { language: getStoredLanguage() };

const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LANGUAGE: {
      const newLanguage = 1 - state.language;
      Cookies.set("language", newLanguage.toString());
      return { ...state, language: newLanguage };
    }
    case SET_LANGUAGE: {
      const newLanguage = Number(action.payload) === 1 ? 1 : 0;
      Cookies.set("language", newLanguage.toString());
      return { ...state, language: newLanguage };
    }
    default:
      return state;
  }
};

export default languageReducer;
